export default {
    SET_CURRENT_ORGANIZATION(state, value) {
        state.currentOrganization = value;
    },
    SET_ORGANIZATIONS_LIST(state, value) {
        state.organizationsList = value.data;
    },
};
